import React from 'react';
import { useAuth } from '../context/Auth';
import { useGlobalContext } from '../context/stateContext';


const RoleBasedComponent = ({ allowedRoles, children, fallback = null }) => {
  const { user } = useGlobalContext();
  const userRole = user?.role;

  if (allowedRoles.includes(userRole)) {
    return children;
  }

  return fallback;
};

export default RoleBasedComponent;